
import firebase from "firebase/app"
import "firebase/analytics"
import { Component, Vue } from "vue-property-decorator"
import { ScrollLock } from "../ScrollLock"
import isMobile from "is-mobile"
import { projectData } from "../data/proj-data"
import ScrollHintArrows from '../components/ScrollHintArrowsVert.vue'

@Component({
  components: { ScrollHintArrows }
})
export default class Projects extends Vue {
  private projects = projectData
  private isMobileDevice = isMobile()
  private projWrapper: HTMLElement | null = null
  private imgLoaded: boolean[] = []

  // ************************
  private scrollActive = true
  // ************************

  created() {
    this.imgLoaded = new Array(this.projects.length).fill(false)
  }

  mounted() {
    this.projWrapper = this.$refs.projWrapper as HTMLElement
    // if (!this.projWrapper) return

    // this.projWrapper.addEventListener('scroll', this.onScroll)
  }

  destroyed() {
    // if (this.projWrapper) {
    //   this.projWrapper.removeEventListener('scroll', this.onScroll)
    // }

    ScrollLock.setScrollLockActive(false)
  }

  // private onScroll = () => {
  //   if (!this.projWrapper) return

  //   if (this.projWrapper.scrollTop > 0) {
  //     ScrollLock.setScrollLockActive(true)
  //   } else {
  //     ScrollLock.setScrollLockActive(false)
  //   }
  // }


  imageLoaded(index: number) {
    setTimeout(() => {
      this.$set(this.imgLoaded, index, true)
    }, 200)
  }

  projectClicked(index: number) {
    this.$emit("project-selected", index)

    const hasAnalytics = typeof (firebase as any).analytics === "function"
    if (!hasAnalytics) return

    const analytics = (firebase as any).analytics()
    if (!analytics) return

    const proj = this.projects[index]
    analytics.logEvent("project_clicked", { project: proj.title })
  }

  cleanClient(value: string) {
    if (!value) return ""
    return value.replace(/<b>\s*client\s*<\/b>\s*:\s*/i, "").trim()
  }

  private fallback =
    'data:image/svg+xml;charset=utf8,<svg xmlns="http://www.w3.org/2000/svg" width="800" height="500"><rect width="100%" height="100%" fill="%23222222"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-family="sans-serif" font-size="16">No image</text></svg>'
}
